// Copyright (c) MobiFactory. All rights reserved.
// This source code is the property of MobiFactory. It is exclusively available to customers who have a valid user license.
// See LICENSE.txt file in the project root for full license information.

import { ref } from "vue";
import Item = Office.Item;
import ItemRead = Office.ItemRead;
import MessageCompose = Office.MessageCompose;
import AppointmentCompose = Office.AppointmentCompose;
import AppointmentRead = Office.AppointmentRead;
import Appointment = Office.Appointment;
import MessageRead = Office.MessageRead;
import Message = Office.Message;
import ItemCompose = Office.ItemCompose;

export type MailboxItem =
  | (Item &
      ItemCompose &
      ItemRead &
      Message &
      MessageCompose &
      MessageRead &
      Appointment &
      AppointmentCompose &
      AppointmentRead)
  | undefined;

const mailboxItem = ref({} as MailboxItem);

function refreshMailboxItem() {
  mailboxItem.value = Office.context.mailbox.item;
}

export function useOfficeState() {
  return {
    mailboxItem,
    refreshMailboxItem,
  };
}
